import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

type DetachedLabelProps = {
  count: number
}

const DetachedLabel = ({ count }: DetachedLabelProps) => {
  if (count === 0) {
    return undefined
  }

  return (
    <Box flexDirection="row" alignItems="center">
      <Box
        flexDirection="row"
        gap="s4"
        background="warningBackground"
        borderRadius={{ all: 'abs012' }}
        paddingX="s8"
        paddingY="s4"
        width="fit-content"
      >
        <Icon.Medium icon="link-remove" color="darker800" />
        <Text size="300" weight="medium" color="grey1000">
          {count}
        </Text>
      </Box>
    </Box>
  )
}

export default DetachedLabel
